
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/heritageprizedraw",
      function () {
        return require("private-next-pages/en/heritageprizedraw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/heritageprizedraw"])
      });
    }
  